var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2498 0.96875H12.1576C12.0045 0.96875 11.8591 1.03906 11.7654 1.15937L5.3232 9.32031L2.23414 5.40625C2.18741 5.34692 2.12785 5.29895 2.05992 5.26593C1.992 5.23292 1.91748 5.21572 1.84195 5.21562H0.749765C0.645077 5.21562 0.587264 5.33594 0.651327 5.41719L4.93102 10.8391C5.13102 11.0922 5.51539 11.0922 5.71695 10.8391L13.3482 1.16875C13.4123 1.08906 13.3545 0.96875 13.2498 0.96875Z",
    fill: "#389E0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckIcon);
export default __webpack_public_path__ + "static/media/green-check-icon.fb4ab89830a3a2e241ddb1e2bc376f39.svg";
export { ForwardRef as ReactComponent };